import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';
import { getUrls } from '@/utils/getUrls';

// 其他类型的接口，如打点接口，ai接口，等
/**
 * 获取sse连接链接
 * @param {*} params clientId
 */
const { BASE_URL } = getUrls();

// [来访者]打点服务的接口
export async function addEventDot(params) {
  const url = `/eventDot/create`;
  return _request({
    method: 'POST',
    url,
    data: params,
  });
}


// [来访者] 反馈问卷提交
export async function addFeedback(params) {
  const url = `/ai/feedback/add`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 清除掉用户和ai对话的聊天记录
export async function clearChatRecord(params) {
  const url = `/ai/clear${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  });
}

// 短的id获取原始id
export async function getOriginalIdByShortId(shortChatAuthId) {
  const url = `/shortId/authId/${shortChatAuthId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 短的shortRiskId获取原始的riskId
export async function getOriginalRiskIdByShortId(shortRiskId) {
  const url = `/shortId/riskId/${shortRiskId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

export function getSSEConnectUrl(params) {
  return BASE_URL + 'sse/createConnect' + _getQuerystr(params);
}
/**
 * 获取sse断开链接
 * @param {*} params clientId
 */
export function closeSSEConnectUrl(params) {
  return BASE_URL + 'sse/closeConnect' + _getQuerystr(params);
}

// 获取所有prompt
export async function getPrompts() {
  const url = `/prompts`;
  return await _request({
    method: 'GET',
    url,
  })
}

export async function getAvatars() {
  const url = `/avatars`;
  return await _request({
    method: 'GET',
    url,
  })
}